<template>
  <div class="cashflow-table mini-cashflow-table">
    <DataTable
      name="financial.cashflow"
      :items="data"
      :tablehdrs="tableheaders.financial.overview_cashflow"
      :itemsperpage="5"
      :paginationOptions="[ 5 ]"
      hidefooter
    >
      <template v-slot:default="{ item }">
        <tr
          class="table-row cashflow-row mini-cashflow-row"
          @click.stop="$router.push({ name: 'financial:page:view', params: { page: 'fluxo', id: item.id }})"
          :class="(item.type === 1 ? 'income' : 'expense')"
        >
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  v-text="getCat(item).icon"
                  class="ma-auto"
                  style="display: table !important;"
                  large
                />
              </template>
              <span>{{ getCat(item).title }}</span>
            </v-tooltip>
          </td>
          <td class="date-col">
            {{ formatDate(item.datetime) }}
          </td>
          <td class="title-col">
            <span>{{ item.title }}</span>
          </td>
          <td>
            <v-icon
              v-if="item.type === 1"
              v-text="`mdi-arrow-up-bold`"
              color="lime accent-4"
              class="mb-1"
              large
            />
            <v-icon
              v-else
              v-text="`mdi-arrow-down-bold`"
              color="deep-orange accent-3"
              large
            />
            <span class="text-body-1 font-weight-black">{{ formatCurrency(item.value) }}</span>
          </td>
          <td class="actions-col">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="$router.push({ name: 'financial:page:view', params: { page: 'fluxo', id: item.id }})"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.financial.cashflow.actions.view }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import cashflow from '@/components/financial/cashflow/mixins/index'

export default {
  components: { DataTable },
  mixins: [ appdata, utils, cashflow ],
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    filtered () {
      let data = (this.get_data || {}).financial || {},
          payments = (data.payments || []).map(pay => ({type: 1, ...pay})),
          expenses = (data.expenses || []).map(exp => ({type: 2, ...exp}))
      return {
        payments,
        expenses
      }
    },
    data () {
      let filtered = this.filtered || {}
      return (this.type === 1 ? filtered.payments : filtered.expenses)
    }
  }
}
</script>

<style src="@/components/financial/cashflow/styles/index.scss" lang="scss"></style>
<style lang="scss">
.mini-cashflow-table {
  #app & {
    .v-data-table__wrapper {
      border-radius: 7px;
      overflow: hidden;
      .v-data-table-header {
        background: #fcfcfc !important;
      }
    }
  }
}

.cashflow-table .mini-cashflow-row {
  #app & {
    cursor: pointer;
    &:hover {
      filter: brightness(110%) !important;
    }
    &.read {
      opacity: 0.74 !important;
    }
    .actions-col {
      min-width: 0px !important;
    }
  }
}
</style>
